<template>
    <div class="m-invite">
        <h5 class="title"></h5>
        <div class="slogen">玩家可以绑定他人，但只能被绑定1次。在绑定玩家中，有部分玩家满足特殊条件，在活动期间内累计消费的5%，将以绑定梦三币的形式返给邀请者（无上限）</div>
        <div class="page-detail">
            <div class="invite-view">

                <div class="tab-view">
                    <div class="tab-item invite" v-if="active_index == 1">
                        <div class="tab-wrapper">
                            <div class="invite-pannel" v-if="$store.state.userinfo.areaId">
                                <div class="invite-item key">
                                    <div class="t-key"></div>
                                    <div class="icon i-key"></div>

                                    <div class="content">
                                        <div class="share-code">
                                            <div class="code-item" v-for="(w,i) in invite_code" :key="i">{{ w }}</div>
                                        </div>
                                    </div>

                                    <div class="u-btn invite copy_code" data-clipboard-action="copy" :data-clipboard-text="user_info.inviteCode" @click="copy_code()" ></div>
                                </div>
                                <div class="invite-item qr">
                                    <div class="t-qr"></div>
                                    <div class="icon i-qr"></div>

                                    <div class="content">
                                        <div class="img" v-if="content && $global.deviceType == 'pc'"><QRcode width="104" height="104" :content="content" :load="false"></QRcode></div>
                                        <div class="img" v-if="content && $global.deviceType != 'pc'"><QRcode width="140" height="140" :content="content" :load="false"></QRcode></div>
                                    </div>

                                    <div class="u-btn invite" @click="$qr_modal({content : content})"></div>                                    
                                </div>
                                <div class="invite-item link">
                                    <div class="t-link"></div>
                                    <div class="icon i-link"></div>

                                    <div class="content c-link">{{ user_info.surl }}</div>

                                    <div class="u-btn invite copy_link" data-clipboard-action="copy" :data-clipboard-text="user_info.koudai + user_info.surl" @click="copy_link()" ></div>
                                </div>
                            </div>

                            <div class="invite-pannel" v-else>
                                <div class="invite-item offline key"></div>
                                <div class="invite-item offline qr"></div>
                                <div class="invite-item offline link"></div>
                            </div>

                            <div class="u-btn user-active" v-if="!$store.state.userinfo.areaId" @click="active()"></div>

                            <p class="notice">每位玩家主动邀请绑定的人数无上限，绑定者之间不能双向绑定。</p>
                        </div>
                    </div>
                    <div class="tab-item join" v-if="active_index == 2">
                        <div class="tab-wrapper">
                            <div class="join-pannel" v-if="!$store.state.userinfo.bindCode">
                                <h6 class="join"></h6>

                                <div class="join-code">
                                    <div class="join-input">
                                        <input type="text" maxlength="6"
                                        v-model="code" class="inputValue" 
                                        >
                                    </div>                      
                                </div>

                                <div class="u-btn join" @click="bind()"></div>

                                <p class="notice">每位玩家只能接受1人的绑定且无法解绑，且绑定者之间不能双向绑定，请谨慎选择。</p>
                            </div>

                            <div class="join-pannel" v-else>
                                <h6 class="join dismiss"></h6>

                                <div class="join-code">
                                    <div class="join-item" v-for="(item, index) in $store.state.userinfo.bindCode.split('')" :key="index"><p>{{ item }}</p></div>                      
                                </div>

                                <p class="notice">每位玩家只能接受1人的绑定且无法解绑，且绑定者之间不能双向绑定，请谨慎选择。</p>
                            </div>                            
                        </div>
                    </div>
                </div>

                <div class="tab-hd">
                    <div class="now-hd" :class="'t-' + active_index"></div>

                    <div class="ui">
                        <div class="u-btn btn-tab t-1" @click="active_index = 1" :class="{'active' : active_index==1}"></div>
                        <div class="u-btn btn-tab t-2" @click="active_index = 2" :class="{'active' : active_index==2}"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 799px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-3.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-3.png);
        }         
    }

    .slogen{
        @if ( $screenWidth == 1000) {
            display: none;
        }
    }

    .invite-view{
        @if ( $screenWidth == 1600) {
            display: flex;
            justify-content: space-between;

            .tab-view{
                width: 511px;
                padding-top: 54px;

                .u-btn.user-active{
                    width: 207px;
                    height: 55px;
                    margin: 0 auto 26px;
                    background-image: url(~@/assets/images/pc/btn-get_invite.png);

                    &:hover{
                        background-image: url(~@/assets/images/pc/btn-get_invite_hover.png);
                    }
                }

                .notice{
                    position: relative;
                    padding-left: 40px;

                    &::after{
                        content: '';
                        display: block;
                        position: absolute;
                        left: 10px;
                        top: 2px;
                        width: 17px;
                        height: 18px;
                        background-image: url(~@/assets/images/modal/icon-warn.png);                        
                    }
                }
            
                .invite-pannel{
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 40px;
                    
                    .invite-item{
                        position: relative;
                        width: 137px;
                        height: 312px;
                        padding-top: 36px;
                        box-sizing: border-box;
                        background-image: url(~@/assets/images/pc/invite-item.png);

                        &.offline.key{
                            background-image: url(~@/assets/images/pc/item-key.png);
                        }

                        &.offline.qr{
                            background-image: url(~@/assets/images/pc/item-qr.png);
                        }
                        
                        &.offline.link{
                            background-image: url(~@/assets/images/pc/item-link.png);
                        }                       


                        .u-btn.invite{
                            position: absolute;
                            left: 50%;
                            bottom: 28px;
                            transform: translateX(-50%);
                            width: 146px;
                            height: 39px;
                            background-position: center;
                            background-repeat: no-repeat;

                            background-image: url(~@/assets/images/pc/btn-invite.png);

                            &:hover{
                                background-image: url(~@/assets/images/pc/btn-invite_hover.png);
                            }
                        }                        

                        .t-key{
                            width: 117px;
                            height: 19px;
                            margin:  0 auto 10px;
                            background-image: url(~@/assets/images/pc/title-key.png);
                        }

                        .t-qr{
                            width: 99px;
                            height: 19px;
                            margin:  0 auto 10px;
                            background-image: url(~@/assets/images/pc/title-qr.png);
                        }
                        
                        .t-link{
                            width: 116px;
                            height: 19px;
                            margin:  0 auto 10px;
                            background-image: url(~@/assets/images/pc/title-link.png);
                        }
                        
                        .i-key{
                            width: 34px;
                            height: 39px;
                            margin: 0 auto;
                            background-image: url(~@/assets/images/pc/icon-lock.png);
                        }

                        .i-key{
                            width: 34px;
                            height: 39px;
                            margin: 0 auto;
                            background-image: url(~@/assets/images/pc/icon-lock.png);
                        }
                        
                        .i-qr{
                            width: 37px;
                            height: 39px;
                            margin: 0 auto;
                            background-image: url(~@/assets/images/pc/icon-qr.png);
                            background-position: top center;
                            background-repeat: no-repeat;
                        }   
                        
                        .i-link{
                            width: 40px;
                            height: 39px;
                            margin: 0 auto;
                            background-image: url(~@/assets/images/pc/icon-link.png);
                        }
                        
                        .share-code{
                            display: flex;
                            flex-wrap: wrap;
                            justify-content: space-between;
                            padding: 0 16px;
                            margin-top: 20px;

                            .code-item{
                                width: 33%;
                                text-align: center;
                                font-size: 32px;
                                color: #2b2824;
                            }
                        }


                    }
                }

                .join-pannel{
                    h6{
                        width: 283px;
                        height: 30px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/pc/title-bind.png);
                        
                        &.dismiss{
                            width: 219px;
                            background-image: url(~@/assets/images/pc/title-bind_dismiss.png);
                        }
                    }

                    .join-code{
                        display: flex;
                        justify-content: center;
                        margin: 30px 0 40px;

                        .join-input{
                            width: 511px;
                            height: 133px;
                            background-image: url(~@/assets/images/pc/K.png);

                            input{
                                display: block;
                                width: 100%;
                                height: 100%;
                                padding: 0 12px;
                                line-height: 100%;
                                border: none;
                                background: none;
                                font-size: 54px;
                                letter-spacing: 6px;
                                color: #c2393f;
                                text-align: center;
                                box-sizing: border-box;                                
                            }
                        }

                        .join-item{
                            width: 59px;
                            height: 133px;
                            margin-right: 5px;
                            background-image: url(~@/assets/images/pc/join-item.png);
                            
                            input,p{
                                display: block;
                                width: 100%;
                                height: 100%;
                                padding: 0 12px;
                                margin: 0 3px;
                                line-height: 133px;
                                border: none;
                                background: none;
                                font-size: 36px;
                                color: #c2393f;
                                text-align: center;
                                box-sizing: border-box;
                            }
                        }
                    }

                    .u-btn.join{
                        width: 211px;
                        height: 55px;
                        margin: 0 auto 26px;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-image: url(~@/assets/images/pc/btn-join.png);

                        &:hover{
                            background-image: url(~@/assets/images/pc/btn-join_hover.png);
                        }
                    }                    
                }
            }

        }@else if( $screenWidth == 1000 ) {
            position: relative;
            padding-top: 600px;
            height: 600px;
            box-sizing: content-box;

            .u-btn.user-active{
                width: 310px;
                height: 82px;
                margin: 0 auto 26px;
                background-image: url(~@/assets/images/m/btn-get_invite.png);
            }

            .notice{
                position: relative;
                padding-left: 40px;
                padding-right: 20px;

                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 10px;
                    top: 2px;
                    width: 26px;
                    height: 26px;
                    background-image: url(~@/assets/images/m/icon-warn.png);                        
                }
            }
        
            .invite-pannel{
                position: relative;
                display: flex;
                justify-content: space-between;
                margin-bottom: 40px;
                
                .invite-item{
                    position: relative;
                    width: 207px;
                    height: 469px;
                    padding-top: 51px;
                    box-sizing: border-box;
                    background-image: url(~@/assets/images/m/invite-item.png);

                    &.offline.key{
                        height: 369px;
                        background-image: url(~@/assets/images/m/item-key.png);
                    }

                    &.offline.qr{
                        height: 369px;
                        background-image: url(~@/assets/images/m/item-qr.png);
                    }
                    
                    &.offline.link{
                        height: 369px;
                        background-image: url(~@/assets/images/m/item-link.png);
                    }                       


                    .u-btn.invite{
                        position: absolute;
                        left: 50%;
                        bottom: 43px;
                        transform: translateX(-50%);
                        width: 177px;
                        height: 55px;
                        background-position: center;
                        background-repeat: no-repeat;

                        background-image: url(~@/assets/images/m/btn-invite.png);
                    }                        

                    .t-key{
                        width: 175px;
                        height: 28px;
                        margin:  0 auto 10px;
                        background-image: url(~@/assets/images/m/title-key.png);
                    }

                    .t-qr{
                        width: 149px;
                        height: 28px;
                        margin:  0 auto 10px;
                        background-image: url(~@/assets/images/m/title-qr.png);
                    }
                    
                    .t-link{
                        width: 175px;
                        height: 28px;
                        margin:  0 auto 10px;
                        background-image: url(~@/assets/images/m/title-link.png);
                    }
                    
                    .i-key{
                        width: 51px;
                        height: 59px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/m/icon-lock.png);
                    }
                    
                    .i-qr{
                        width: 55px;
                        height: 59px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/m/icon-qr.png);
                        background-position: top center;
                        background-repeat: no-repeat;
                    }   
                    
                    .i-link{
                        width: 60px;
                        height: 59px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/m/icon-link.png);
                    }
                    
                    .share-code{
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        padding: 0 16px;
                        margin-top: 30px;

                        .code-item{
                            width: 33%;
                            text-align: center;
                            font-size: 48px;
                            color: #2b2824;
                        }
                    }


                }
            }

            .join-pannel{
                height: 600px;

                h6{
                    width: 337px;
                    height: 35px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/m/title-bind.png);
                    
                    &.dismiss{
                        width: 261px;
                        background-image: url(~@/assets/images/m/title-bind_dismiss.png);
                    }
                }

                .join-code{
                    display: flex;
                    justify-content: space-between;
                    margin: 30px 0 40px;
                    padding: 0 18px;

                    .join-input{
                        width: 711px;
                        height: 133px;
                        margin: 0 auto;
                        background-image: url(~@/assets/images/m/app-K.png);

                        input{
                            display: block;
                            width: 100%;
                            height: 100%;
                            padding: 0 12px;
                            line-height: 100%;
                            border: none;
                            background: none;
                            font-size: 54px;
                            letter-spacing: 6px;
                            color: #c2393f;
                            text-align: center;
                            box-sizing: border-box;                                
                        }
                    }

                    .join-item{
                        width: 79px;
                        height: 133px;
                        margin-right: 5px;
                        background-image: url(~@/assets/images/m/join-item.png);
                        
                        input,p{
                            display: block;
                            width: 100%;
                            height: 100%;
                            padding: 0 12px;
                            line-height: 133px;
                            border: none;
                            background: none;
                            font-size: 36px;
                            color: #c2393f;
                            text-align: center;
                            box-sizing: border-box;
                        }
                    }
                }

                .u-btn.join{
                    width: 310px;
                    height: 82px;
                    margin: 0 auto 26px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url(~@/assets/images/m/btn-join.png);
                }                    
            }

        }            
    }

    .tab-hd{
        position: relative;
        
        @if ( $screenWidth == 1600) {

            position: relative;
            display: flex;
            transform: translateY(-50px);

            .now-hd{
                width: 588px;
                height: 588px;

                &.t-1{
                    background-image: url(~@/assets/images/pc/tab-invite.png);
                }

                &.t-2{
                    background-image: url(~@/assets/images/pc/tab-join.png);
                }                
            }

            .ui{
                margin-left: -80px;
                padding-top: 165px;
            }

            .btn-tab{
                width: 142px;
                height: 142px;
                background-position: center;
                background-repeat: no-repeat;
                margin: 12px 0;

                &.t-1{
                    background-image: url(~@/assets/images/pc/btn-tab_invite.png);

                    &:hover,&.active{
                        background-image: url(~@/assets/images/pc/btn-tab_invite_act.png);
                    }
                }

                &.t-2{
                    background-image: url(~@/assets/images/pc/btn-tab_join.png);

                    &:hover,&.active{
                        background-image: url(~@/assets/images/pc/btn-tab_join_act.png);
                    }                    
                }                
            }

        }@else if( $screenWidth == 1000 ) {
            position: absolute;
            left: 50%;
            top: 0;
            display: flex;
            transform: translate(-50%,-50px);

            .now-hd{
                width: 588px;
                height: 588px;

                &.t-1{
                    background-image: url(~@/assets/images/pc/tab-invite.png);
                }

                &.t-2{
                    background-image: url(~@/assets/images/pc/tab-join.png);
                }                
            }

            .ui{
                margin-left: -100px;
                padding-top: 138px;
            }

            .btn-tab{
                width: 171px;
                height: 171px;
                background-position: center;
                background-repeat: no-repeat;
                margin: 12px 0;

                &.t-1{
                    background-image: url(~@/assets/images/m/btn-tab_invite.png);

                    &.active{
                        background-image: url(~@/assets/images/m/btn-tab_invite_act.png);
                    }
                }

                &.t-2{
                    background-image: url(~@/assets/images/m/btn-tab_join.png);

                    &.active{
                        background-image: url(~@/assets/images/m/btn-tab_join_act.png);
                    }                    
                }                
            }
        }          
    }

    @if ( $screenWidth == 1600) {

    }@else if( $screenWidth == 1000 ) {

    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<style>
    .qr .img{
        width: 104px;
        height: 104px;
        margin: 10px auto 0;
    }

    @media screen and (min-width: 375px) and (max-width: 999px){
        .qr .img{
            width: 140px;
            height: 140x;
            margin: 30px auto 0;
        }
    }


    .link .content{
        margin-top: 10px;
        padding: 0 16px;
        text-align: center;
        word-break: break-all;
    } 
    
    @media screen and (min-width: 375px) and (max-width: 999px){
        .link .content{
            margin-top: 30px;
        } 
    }    
</style>

<script>
export default {
    data(){
        return {
            active_index : 1,
            user_info : {},
            content : '',
            code: '',
            invite_code : [],           
        }
    },
    computed:{
        aid (){
            return this.$store.state.userinfo.areaId;
        },
    },
    watch: {
        aid: {
            handler(newVal, oldVal) {
                //todo
                if(newVal != oldVal)return this.render();
                //this.render();
            },
            deep: true
        },        
    },      
    mounted(){
        if(this.$store.state.login && this.$store.state.userinfo.areaId){
            this.render();
        }
    },
    methods : {
        active (){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }            
        },
        render (){
            this.$post(ajax_url_map.invite,{
                success : (data) => {
                    this.user_info = data.data;
                    this.content = data.data.surl;
                    this.invite_code = this.code_split(this.user_info.inviteCode);
                },
                error : () => {},
            },{})
        },
        code_split(code){
            return code.split('');
        },
        copy_code(){
            let _this = this;
            let clipboard = new _this.clipboard(".copy_code");
            clipboard.on('success', function () {
              //_this.$toast("复制成功");
              _this.$key_modal({inviteCode : _this.invite_code});
              clipboard.destroy()
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
              clipboard.destroy()
            });            
        },
        copy_link(){
            let _this = this;
            let clipboard = new _this.clipboard(".copy_link");
            clipboard.on('success', function () {
              _this.$copy_modal();
              clipboard.destroy()
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
              clipboard.destroy()
            });            
        },
        keyboard(e, index) {
            let domNode = document.getElementsByClassName("inputValue"),
                currInput = domNode[index],
                nextInput = domNode[index + 1],
                lastInput = domNode[index - 1];
            console.log(e.keyCode)
            if (e.keyCode != 8) {
                if (index < this.inputList.length - 1) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            } else {
                if (index != 0) {
                    lastInput.focus();
                }
            }
            },
        expurgate(index) {
            this.inputList[index].pinless = "";
        },
        bind (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }                  

            if(this.code.length < 6)return this.$toast('请输入邀请码')
            this.$axios.post(ajax_url_map.apply_invite,{
                inviteCode : this.code,
            })
            .then(
                res => {
                    this.$success_modal();
                    this.$store.commit("$_setInviteCode", this.code);
                    //$_setInviteCode
                },
                rej => {
                    this.$error_modal({text : rej.message});                 
                }
            );
        }, 

    },
}
</script>


// WEBPACK FOOTER //
// src/views/invite.vue